import React, { ForwardedRef, useCallback } from 'react';

import { View } from 'react-native';

import { useDispatch } from 'react-redux';

import { showPlayer } from 'store/player/actions';
import { StreamTypes } from 'store/player/actions.types';
import { RBChannel } from 'store/railsBuilder/reducer.types';

import parseVideoItem from 'services/data-manager/parsing/parseVideoItem';
import { ContentType } from 'services/data-manager/types';

import { useCast } from 'utils/cast/useCast';
import useGetLiveProgram from 'utils/hooks/useGetLiveProgram';

import RibbonTouchable from 'components/CustomButtons/RibbonTouchable';
import ChannelCard from 'components/Ribbon/components/ChannelCard/ChannelCard';
import { OnUavAnalyticsProps, StandardUavProps } from 'components/Ribbon/types';

type Props = {
    item: RBChannel;
    isCollection?: boolean;
    testID?: string;
    index?: number;
    totalNumberOfItems?: number;
} & OnUavAnalyticsProps &
    StandardUavProps;

const ChannelRibbon = (
    {
        item: channel,
        isCollection,
        onRailsSelection,
        railId,
        templateId,
        testID,
        index = 0,
        totalNumberOfItems,
    }: Props,
    forwardedRef?: ForwardedRef<View | undefined>,
) => {
    const dispatch = useDispatch();
    const onGetLiveProgram = useGetLiveProgram();

    const { isCastConnected, cast } = useCast();

    const handlePress = useCallback(async () => {
        const liveProgram = await onGetLiveProgram(channel.editorial.id);
        const videoItem = parseVideoItem({ channel, program: liveProgram });
        const playbackType = StreamTypes.live;

        onRailsSelection?.({ id: videoItem.id, playbackType, index });

        if (isCastConnected) {
            cast(videoItem, playbackType);
        } else {
            dispatch(
                showPlayer({
                    videoItem,
                    playbackType,
                    railId,
                    templateId,
                }),
            );
        }
    }, [
        channel,
        isCastConnected,
        cast,
        onRailsSelection,
        railId,
        templateId,
        index,
    ]);

    return (
        <RibbonTouchable
            ref={forwardedRef}
            metadataType={ContentType.ChannelItem}
            isCollection={isCollection}
            onPress={handlePress}
            testID={testID}
            RibbonContentComponent={
                <ChannelCard
                    item={channel}
                    index={index}
                    totalNumberOfItems={totalNumberOfItems}
                    isCollection={isCollection}
                />
            }
        />
    );
};

export default React.forwardRef(ChannelRibbon);
